export default __webpack_public_path__ + "7124eb50fc8227c78269f2d995637ff5.woff";